export const STATES = {
  SAFE: "safe",
  ASK: "ask",
  UNSAFE: "unsafe",
};

const ALLERGEN_ALIASES = {
  peanuts: "peanut",
  eggs: "egg",
  tree_nuts: "tree_nut",
  dairy: "milk",
  gluten: "wheat",
};

export function normalizeAllergenId(id) {
  const key = String(id || "").trim().toLowerCase();
  return ALLERGEN_ALIASES[key] || key;
}

export const FOOD_PRACTICE_FOODS = [
  {
    id: "apple",
    label: "Whole apple",
    usuallyContains: [],
    mayContain: [],
  },
  {
    id: "banana",
    label: "Whole banana",
    usuallyContains: [],
    mayContain: [],
  },
  {
    id: "carrot",
    label: "Plain carrot sticks",
    usuallyContains: [],
    mayContain: [],
  },
  {
    id: "broccoli",
    label: "Plain broccoli",
    usuallyContains: [],
    mayContain: [],
  },
  {
    id: "rice_bowl",
    label: "Plain white rice",
    usuallyContains: [],
    mayContain: [],
  },
  {
    id: "bread_slice",
    label: "Regular wheat bread",
    usuallyContains: ["wheat"],
    mayContain: ["egg", "milk", "sesame"],
  },
  {
    id: "cookie",
    label: "Packaged cookie",
    usuallyContains: [],
    mayContain: ["wheat", "egg", "milk", "peanut", "tree_nut"],
  },
  {
    id: "pancakes",
    label: "Plain pancake made with wheat, egg, and milk",
    usuallyContains: ["wheat", "egg", "milk"],
    mayContain: [],
  },
  {
    id: "waffles",
    label: "Plain waffle made with wheat, egg, and milk",
    usuallyContains: ["wheat", "egg", "milk"],
    mayContain: [],
  },
  {
    id: "cheese_pizza_slice",
    label: "Regular cheese pizza slice",
    usuallyContains: ["milk", "wheat"],
    mayContain: [],
  },
  {
    id: "peanut_butter",
    label: "Peanut butter",
    usuallyContains: ["peanut"],
    mayContain: [],
  },
  {
    id: "cheese",
    label: "Cheese",
    usuallyContains: ["milk"],
    mayContain: [],
  },
  {
    id: "egg",
    label: "Egg",
    usuallyContains: ["egg"],
    mayContain: [],
  },
  {
    id: "hummus",
    label: "Hummus",
    usuallyContains: ["sesame"],
    mayContain: [],
  },
  {
    id: "soy_sauce",
    label: "Regular soy sauce",
    usuallyContains: ["soy", "wheat"],
    mayContain: [],
  },
  {
    id: "shrimp",
    label: "Shrimp",
    usuallyContains: ["shellfish"],
    mayContain: [],
  },
  {
    id: "granola_bar",
    label: "Granola bar",
    usuallyContains: [],
    mayContain: ["wheat", "peanut", "tree_nut", "milk", "soy"],
  },
];

export function getFoodUsuallyContains(food) {
  return (food?.usuallyContains || food?.guaranteedAllergens || []).map(normalizeAllergenId);
}

export function getFoodMayContain(food) {
  return (food?.mayContain || food?.possibleAllergens || []).map(normalizeAllergenId);
}

export function classifyFood(food, activeAllergens = []) {
  if (!food) return STATES.ASK;

  const active = new Set((activeAllergens || []).map(normalizeAllergenId));
  const usuallyContains = getFoodUsuallyContains(food);
  const mayContain = getFoodMayContain(food);

  if (usuallyContains.some((allergen) => active.has(allergen))) {
    return STATES.UNSAFE;
  }
  if (mayContain.some((allergen) => active.has(allergen))) {
    return STATES.ASK;
  }

  return STATES.SAFE;
}
